import { css } from "@emotion/css";
import { ScriptingLanguage } from "@octopusdeploy/octopus-server-client";
import { noOp } from "@octopusdeploy/utilities";
import { useState } from "react";
import { contentContainerStyles } from "~/areas/infrastructure/components/MachineSettings/Endpoints/KubernetesAgent/Styles";
import { CodeEditor, type Language, type TextFormat } from "~/components/CodeEditor/CodeEditor";
import { Note } from "~/components/form";
type UninstallKubernetesMonitorPageProps = {
    generateHelmCommand: (selectedLanguage: ScriptingLanguage | Language | TextFormat) => string;
};
export function UninstallKubernetesMonitorPage({ generateHelmCommand }: UninstallKubernetesMonitorPageProps) {
    const [selectedLanguage, setSelectedLanguage] = useState<ScriptingLanguage | Language | TextFormat>(ScriptingLanguage.Bash);
    const helmCommand = generateHelmCommand(selectedLanguage);
    const helmCommandLineCount = helmCommand.split(/\r\n|\r|\n/).length;
    //adjust the height of the code editor based on the number of lines in the helm command
    const codeEditorContainer = css({
        // 1.25rem per line (line height) and roughly 3rem of padding/margins/scrollbars
        minHeight: `calc((${helmCommandLineCount} * 1.25rem) + 3rem)`,
    });
    return (<div className={contentContainerStyles}>
            <p>After running the command below, Octopus Server will no longer receive live status for deployments with this agent.</p>
            <CodeEditor value={helmCommand} readOnly lineWrapping={false} showCopyButton showLineNumbers={false} language={selectedLanguage} allowFullScreen containerClassName={codeEditorContainer} settingsOverride={{ theme: "default", wordWrap: false }} onChange={noOp} scriptingLanguageSelectorOptions={{
            supportedLanguages: [ScriptingLanguage.Bash, ScriptingLanguage.PowerShell],
            onScriptingLanguageChanged: (syntax: ScriptingLanguage | Language | TextFormat) => setSelectedLanguage(syntax),
        }}/>
            <Note>This command will upgrade your Kubernetes Agent if it is not the latest version.</Note>
            <Note>Once you've run the command, run a health check on your agent to update the detected configuration.</Note>
        </div>);
}
